import api from "./axios";

class ServiceAux {
  async getCep(cep) {
    const { data } = await api.get(`/aux/cep/${cep}`);
    
    return data;
  }
}

export default new ServiceAux()